export class Tenant {
  public static Id: string = "1c25b067-e687-4b36-afea-e3930182fc4a";
  public static Name: string = "RateTable";
  public static Header: string = "Tenant";
}

export class CensusLiteMethod {
  public static GroupDetails: string =
    "broker/{brokerId}/groups/{marketsegmentId}";
  public static PostalDetails: string = "postalcodes/";
  public static SICCode: string = "siccode/";
  public static GetExistingGroup: string = "group/{id}";
  public static AddGroup: string = "group";
  public static PostMaterCensusDetail: string = "census";
  public static PostMasterCensusDetailForList: string = "InsertMembers";
}

export class PlanLiteMethod {
  public static QuotableDates: string = "plans/{stateId}/quotabledates";
  public static GetCarrierLogos: string = "carrierlogos/SIQ";
  public static LogoFilePath: string = "carrierlogos/{*filePath}";
}

export class NQSPlanApiMethod {
  public static GetActiveCarriers: string = "literating/RateTableCarriers";
  public static GetCarriers: string = "literating/RateTableCarriers";
  public static GetPackages: string = "literating/GetNHWSQuotablePlans";
  public static GetNetworksLite: string = "literating/GetNetworksLite";
  public static GetPlanRates: string = "literating/GetEmployeeRates";
  public static GetPackagePlanRates: string =
    "literating/RateTableQuotablePlans";
}

export class Client {
  static ClientId: string = "rate_tables_web";
  static ClientScopes: string =
    "openid profile email read write RatesTable_Api Quote_Lite_Api Plan_Lite_Api Census_Lite_Api Broker_Lite_Api Document_Manager_Api";
}

export class RateTableAPIMethod {
  public static postRateTableDetail: string = "ratetable/rateTableDetails";
  public static postRateTableGenerate: string = "ratetable/GenerateEmail";
  public static postDownloadExcelRateTableGenerate: string =
    "ratetable/DownloadExcel/{Id}";
  public static postDownloadPDFRateTableGenerate: string =
    "ratetable/DownloadPDF/{Id}";
  public static getRateTableById: string = "ratetable/{Id}";
  public static getSupportedBrowsers: string = "ratetable/supportedbrowsers";
}

export class ValidationMessage {
  static SelectPackageNoPackageCoversAllMembers =
    "There is no package in this carrier that covers all members. Please review your carrier selection and try again.";
  static SelectPackageSelectedPackageNotCoversAllMembers =
    "Selected package does not cover all members. Please select another package.";
  static noPackagesAvailableMsg =
    "No packages available. Please review your carrier selection and try again.";
  static ServerError = `A system error has occurred, please try again. If the problem persists please contact the Help Desk. `;
  static SessionExpireError = `User session has expired.`;
  static IdleSession = `Your session is idle. You'll be redirected back to WBQuote in few seconds.`;
  static alertMessage = `Message`;
  static disclaimerText = `Thank you for visiting the Word & Brown® website (hereinafter, the “Website”), which is owned
    and operated by Word & Brown Insurance Administrators, Inc. (hereinafter, “Word & Brown”; “We”; or “Our”),
     to use the Rate Table Calculator (“RTC”). The information included in this Website was collected from 
     sources that are considered reliable including, without limitation, rate information provided by carriers. 
     We have not verified nor can we guarantee the accuracy, timeliness or completeness of such information. 
     This Website is provided on an “AS-IS” basis. Thus, it is solely your responsibility to verify any
      information you obtain from this Website and the RTC before making decisions or incurring costs based 
      on such information.  Further, the information provided herein is not intended to be used to make 
      eligibility decisions or any similar purpose.  This information also is not intended for dissemination.
   This disclaimer incorporates and supplements other Website disclaimers and its Terms of Use.`;
}
export class UserApiMethod {
  public static GetAgencyDetails: string = "agency/userId/{userId}";
  public static GetUserInformation: string = "users/{userId}/user-details";
  public static GetBrokerAgencyDetails: string = "agency/broker/{brokerId}";
  public static GetAllCarrierLogos: string = "Carrier/GetAllCarrierLogos";
}
